import React from 'react';
import { getProjectState } from 'app/stores/project';
import { EditBoundsPoints } from 'app/views/components/editor/tools/edit/EditBoundsPoints';
import { EditImage } from 'app/views/components/editor/tools/edit/EditImage';
import { EditText } from 'app/views/components/editor/tools/edit/EditText';
import { EditTwoPoints } from 'app/views/components/editor/tools/edit/EditTwoPoints';
import { EditZoom } from 'app/views/components/editor/tools/edit/EditZoom';
import { useConnect } from 'app/views/hooks/useConnect';
import { useItemSelector } from 'app/views/hooks/useItemSelector';
import { useTextEditor } from 'app/views/hooks/useTextEditor';
const ToolEditComponent = {
    Arrow: EditTwoPoints,
    Line: EditTwoPoints,
    Ellipse: EditBoundsPoints,
    Rect: EditBoundsPoints,
    Blur: EditBoundsPoints,
    Spot: EditBoundsPoints,
    Zoom: EditZoom,
    Text: EditText,
    Image: EditImage,
};
const Style = {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
};
export const Interaction = () => {
    const ref = React.useRef(null);
    const stateProps = useConnect(state => {
        const project = getProjectState(state);
        const { selection, markers } = project;
        const selectedId = selection[0];
        return {
            selectedItemAlias: selectedId
                ? markers[selectedId].alias
                : undefined,
        };
    });
    const [setSelectorNode] = useItemSelector();
    const [setTextEditorNode] = useTextEditor();
    const { selectedItemAlias } = stateProps;
    const EditComponent = selectedItemAlias
        ? ToolEditComponent[selectedItemAlias]
        : undefined;
    const setRef = React.useCallback((node) => {
        setSelectorNode(node);
        setTextEditorNode(node);
        ref.current = node;
    }, [setSelectorNode, setTextEditorNode]);
    return (React.createElement("div", { className: "interactions-wrapper user-select-none touch-action-none", "data-test-id": "interactions", style: Style, ref: setRef }, EditComponent && React.createElement(EditComponent, null)));
};
